import React from 'react';
import ReactJson from 'react-json-view';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import styled from 'styled-components';

import Card from '@components/Card';
import InputStandard from '@components/InputStandard';
import useAPI from '@hooks/useAPI';
import Button from '@shared/Button';
import Modal from '@shared/Modal';
import Spinner from '@shared/Spinner';
import { ReactComponent as DownArrowIcon } from '@src/assets/escher/icons/arrow-drop-down.svg';
import { ReactComponent as UpArrowIcon } from '@src/assets/escher/icons/arrow-drop-up.svg';
import { ReactComponent as FileCopy } from '@src/assets/escher/icons/file-copy.svg';
import ButtonsRow from '@styled/Containers/ButtonsRow';
import P from '@styled/Elements/P';
import UpdateList from '@utils/updateList';
import { copyToClipboard } from '@utils/utils';

const Container = styled.div`
  width: 800px;
  height: 80vh;
  word-break: break-all;
  overflow: scroll;
`;

const EntityContainer = styled.div`
  padding: 10px 40px;
`;

const CopyToClipboardButton = ({ src }) => {
  const handleCopy = () => {
    copyToClipboard(JSON.stringify(src, null, 2));
    toast.success('Copied entity JSON to clipboard');
  };

  return (
    <Button onClick={handleCopy} color='blue'>
      <FileCopy />
    </Button>
  );
};

const EntityItem = ({ label, src }) => {
  const [expanded, setExpanded] = React.useState(true);
  const toggleExpanded = () => setExpanded(!expanded);

  return (
    <div>
      <h2>
        <span onClick={toggleExpanded}>
          {expanded ? <UpArrowIcon /> : <DownArrowIcon />}
          {label}
        </span>
        &nbsp;
        <CopyToClipboardButton src={src} />
      </h2>
      {expanded && (
        <EntityContainer>
          <ReactJson collapsed={2} src={src} />
        </EntityContainer>
      )}
    </div>
  );
};

export default function EntityModal({ entity, handleClose }) {
  const entityRequest = useAPI(
    'get',
    'ScreenConsoleApi',
    `entity/${entity}`,
    '',
    true,
    '',
    false
  );
  const { isLoading, response } = entityRequest;
  const data = response?.body || [];
  const hasData = data && data.length;

  let headerText = `Lookup - ${entity}`;
  if (hasData > 1) {
    headerText = `Lookup - ${entity} - ${hasData} results`;
  }
  if (hasData === 0) {
    headerText = `Lookup - ${entity} - ${hasData} results`;
  }

  return (
    <Modal id='modal' open={entity} toggle={handleClose}>
      <Card title={headerText} shadow>
        <Container>
          {isLoading && <Spinner />}
          {hasData === 0 && !isLoading && <div>No results found for '{entity}'.</div>}
          {hasData > 0 &&
            data.map(item => {
              const src = item || {};
              const hasResults = data && data.length;
              let fullName = '';
              let listName = '';
              if (src && src.names) {
                fullName = src.names[0].full_name_all;
                listName = src.list_metadata.list_name;
              }
              let entityLabel = `Entity ${entity} - ${fullName} (${listName})`;

              return <EntityItem src={src} label={entityLabel} />;
            })}
        </Container>
      </Card>
    </Modal>
  );
}
